import React from "react";
import cn from "classnames";
import { SavingIcon } from "components/icons/components/SavingIcon";
import { SavedIcon } from "components/icons/components/SavedIcon";
import { makeStyles, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    width: "87px",
  },
  verticalContainer: {
    flexDirection: "column",
  },
  noLabelContainer: {
    width: "22px",
  },
  label: {
    fontFamily: "'Inter', 'sans-serif'",
    marginLeft: "8px",
  },
  verticalLabel: {
    textAlign: "center",
    marginLeft: "0",
  },
}));

export const Saving = ({
  saving,
  hideLabels,
  vertical = false,
  loadingText = "Saving...",
  successText = "Campaign saved",
}) => {
  const classes = useStyles();
  return (
    <div
      className={cn(classes.container, {
        [classes.noLabelContainer]: hideLabels,
        [classes.verticalContainer]: vertical,
      })}
    >
      {saving ? (
        <>
          {hideLabels ? <CircularProgress size={18} /> : <SavingIcon />}
          {!hideLabels && (
            <span className={cn(classes.label, { [classes.verticalLabel]: vertical })}>{loadingText}</span>
          )}
        </>
      ) : (
        <>
          <SavedIcon stroke={"#AEAFC7"} />{" "}
          {!hideLabels && (
            <span className={cn(classes.label, { [classes.verticalLabel]: vertical })}>{successText}</span>
          )}
        </>
      )}
    </div>
  );
};
